<template>
  <ul class="query-log-nav">
    <li class="item" :class="{'-active': listActive === 'query-success'}">
      <skeleton-loader width="163px" height="21px" v-if="loading"/>
      <button class="handler" @click="$emit('change', 'query-success')" v-else>Consultas com sucesso</button>
    </li>
    <li class="item" :class="{'-active': listActive === 'query-error'}">
      <skeleton-loader width="133px" height="21px" v-if="loading"/>
      <button class="handler" @click="$emit('change', 'query-error')" v-else>Consultas com erro</button>
    </li>
    <li class="item" :class="{'-active': listActive === 'per-query'}">
      <skeleton-loader width="83px" height="21px" v-if="loading"/>
      <button class="handler" @click="$emit('change', 'per-query')" v-else>Por consulta</button>
    </li>
  </ul>
</template>

<script>
import SkeletonLoader from '@/support/components/loader/SkeletonLoader.vue';

export default {
  name: 'QueryLogNav',

  props: {
    listActive: {
      required: true,
      type: String,
    },

    loading: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  components: {
    SkeletonLoader,
  },
};
</script>

<style lang="scss" scoped>
.query-log-nav {
  @apply ml-auto;
  @apply flex;
  @apply gap-4;

  > .item .handler {
    @apply font-bold;
    @apply text-secondary-700;
    @apply text-sm;
    @apply outline-none;
  }

  > .item.-active .handler {
    @apply text-primary-500;
  }
}
</style>
